import React, { useEffect, useRef, useState } from 'react';
// import mujaImage from '../../assets/muja.jpeg'; // Removed unused import
import './LunarcraterImageEnhancement.css';
import moon1 from '../../assets/moon1.jpeg';
import moon2 from '../../assets/moon2.jpeg';
import moon3 from '../../assets/moon3.jpeg';

const WorkforceSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [typedText, setTypedText] = useState('');
  const [showPersona, setShowPersona] = useState(false);
  const [showCoachingCard, setShowCoachingCard] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % 3);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(slideInterval);
  }, []);

  const fullText = "Work on enhancing permanently shadowed regions of lunar craters using deep learning and GAN-based techniques to improve image clarity and detail. By boosting the Signal-to-Noise Ratio (SNR), this project enables more accurate geological analysis, better landing site selection, and deeper insights for scientific exploration. With advanced image processing methods, it supports researchers in unlocking new possibilities for space studies and lunar missions.";
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '-50px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      // Show coaching card immediately when section becomes visible
      setShowCoachingCard(true);

      // Start typewriter effect only when user navigates to this section
      let currentIndex = 0;
      const typeInterval = setInterval(() => {
        if (currentIndex <= fullText.length) {
          setTypedText(fullText.slice(0, currentIndex));
          currentIndex++;
        } else {
          clearInterval(typeInterval);
        }
      }, 50);

      return () => clearInterval(typeInterval);
    }
  }, [isVisible, fullText]);

  return (
    <section className="workforce-section" ref={sectionRef}>
      <div className="workforce-container">
        <div className={`workforce-header ${isVisible ? 'animate-up' : ''}`}>
          <p className="workforce-subtitle">Lunar Crater Image Enhancement</p>
          <h2 className="workforce-title">Deep learning approach to enhance crater images and improve visibility for lunar research.</h2>
        </div>
        <div className="workforce-content">
          <div className="workforce-left-section">
            <div className={`moon-logo-section ${isVisible ? 'slide-in-left' : ''}`}>
              <div className="moon-logo-large">
                <svg width="90" height="90" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#10b981" strokeWidth="2" />
                  <circle cx="12" cy="12" r="6" fill="#10b981" opacity="0.3" />
                  <circle cx="15" cy="9" r="1.5" fill="#10b981" />
                  <circle cx="9" cy="15" r="1" fill="#10b981" />
                  <circle cx="16" cy="14" r="0.8" fill="#10b981" />
                  <circle cx="8" cy="10" r="0.6" fill="#10b981" />
                  <circle cx="17" cy="11" r="0.4" fill="#10b981" />
                </svg>
              </div>
              <div className="moon-project-info">
                <h3>Lunar Research Initiative</h3>
                <p>Advanced Crater Analysis</p>
              </div>
            </div>
          </div>

          <div className="workforce-center-section">
            <div className={`expanding-container ${typedText ? 'expanded' : ''}`}>
              <p className="typewriter-text">{typedText}</p>
              <span className="cursor">|</span>
            </div>

            <div className={`coaching-session-card ${showCoachingCard ? 'slide-up' : ''}`}>



              {/* Image Slideshow Container - positioned above the feature points */}
              <div className="image-slideshow-container">
                <div className="slideshow-wrapper">
                  <div className={`slide ${currentSlide === 0 ? 'active' : ''}`}>
                    <img src={moon1} alt="Moon Research 1" className="slide-image" />
                  </div>
                  <div className={`slide ${currentSlide === 1 ? 'active' : ''}`}>
                    <img src={moon2} alt="Moon Research 2" className="slide-image" />
                  </div>
                  <div className={`slide ${currentSlide === 2 ? 'active' : ''}`}>
                    <img src={moon3} alt="Moon Research 3" className="slide-image" />
                  </div>
                </div>
                <div className="slide-dots">
                  <button
                    className={`dot ${currentSlide === 0 ? 'active' : ''}`}
                    onClick={() => setCurrentSlide(0)}
                  ></button>
                  <button
                    className={`dot ${currentSlide === 1 ? 'active' : ''}`}
                    onClick={() => setCurrentSlide(1)}
                  ></button>
                  <button
                    className={`dot ${currentSlide === 2 ? 'active' : ''}`}
                    onClick={() => setCurrentSlide(2)}
                  ></button>
                </div>
              </div>

              <div className="coaching-features-combined">
                <div className="feature-item">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#059669" />
                  </svg>
                  <span>Advanced image processing algorithms</span>
                </div>
                <div className="feature-item">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#059669" />
                  </svg>
                  <span>Enhanced geological analysis</span>
                </div>
                <div className="feature-item">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#059669" />
                  </svg>
                  <span>Better landing site selection</span>
                </div>
                <div className="feature-item">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#059669" />
                  </svg>
                  <span>Scientific exploration support</span>
                </div>
              </div>
            </div>

            <div className="github-btn-container">
              <a
                href="https://github.com/Mujakathali/SIH-LUNAR_CRATES_DETECTION_AND_ENHANCEMENT-"
                target="_blank"
                rel="noopener noreferrer"
                className="github-btn"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                </svg>
                View on GitHub
              </a>
            </div>
          </div>

          <div className="workforce-right-section">
            {/* Add any right section content here if needed */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkforceSection;
